<template>
  <div>
    <RemoteComponent
      v-if="aitaxToken"
      ref="RemoteComponentRef"
      :base="microServiceVue3"
      :show-loading="true"
      service="bankDataUploader"
      :src="src"
      @doneOrPass="doneOrPass"
      @done="handleBankDataUploaderDone"
      @openMatchModal="openMatchModal"
      @messageInfo="messageInfos"
      @messageInfoSuccess="messageInfoSuccess"
      @resetMatch="resetMatchs"
      type="iframe"
      style="height:calc(100vh - 110px)"
    ></RemoteComponent>
  </div>
</template>
<script>
import {getToken} from "@/utils/auth.js";
import {Modal} from 'ant-design-vue';
import {resetMatch, getTestingRiskCheck} from "@/api/api"
import {message} from "ant-design-vue";
import RemoteComponent from "@/components/RemoteComponent.vue";
import {getAitaxToken} from "@/api/auth";

const microServiceVue3 = process.env.VUE_APP_MICRO_SERVICE_VUE3;

export default {
  components: {RemoteComponent},
  data(){
    return{
      src:'',
      aitaxToken:'',
    }
  },
  props: {
    data:{
      type:Object
    },
    reportId:[String,Number],
    programId:String,
    state: {
      type: Number,
      default: () => 1,
    },
    isfinish: {
      type: Boolean
    },
    skuId:{
      type: String,
      required: false
    }
  },
  computed:{
    offlineHandle(){
      return this.$route.query.offlineHandle||1;
    },
    microServiceVue3(){
      return microServiceVue3;
    },
    projectId(){
      return 20
      //return this.$route.params.projectid;
    },
    abilityCode(){
      return this.data.code;
    }
  },
  async mounted() {
    if (this.$route.query.token){
      this.aitaxToken = this.$route.query.token
    }else {
      const res = await getAitaxToken()
      this.aitaxToken = res.data
    }

    this.domSuccsses()
  },
  methods: {
    resetMatchs(e) {
      Modal.confirm({
        title: '已匹配的科目将被全部删除，确认清空匹配吗？',
        //icon: createVNode(ExclamationCircleFilled),
        style: {
          top: '40vh',
          width: '450px'
        },
        async onOk() {
          const res = await resetMatch(this.programId)
          if (res.code == 200) {
            message.success('重置成功')
            this.$refs.RemoteComponentRef.invoke('resetMatchSuccess')

          }
        },
        onCancel() {
        },
        class: 'test',
      });
    },
    messageInfos(e) {
      message.info(e)
    },
    messageInfoSuccess(e) {
      message.success(e)
    },
    openMatchModal(e) {
      this.$refs.matchModalRef.isConfim = e
    },
    doneOrPass() {
      console.log('接收到生成文件了')

      // this.$router.replace({
      //   name: "oemGuardV4Success", query: {
      //     redirect_uri: this.$route.query.redirect_uri?decodeURIComponent(this.$route.query.redirect_uri):''
      //   }
      // })
      this.$emit('doneOrPass')
    },

    handleBankDataUploaderDone(params) {
      const dataPeriod = params.dataPeriod;
      const uuid = params.programId;

      delete params.dataPeriod;
      delete params.uuid;

      this.$router.push({
        name: "riskDetails",
        params: {
          dataPeriod,
          uuid,
        },
        query: {
          info: JSON.stringify(params),
        },
      });
    },
    async domSuccsses() {
      // const res = await getTestingRiskCheck({
      //   serialNo: this.programId,
      // });
      // if (res.code == 200) {
      //   let value = res.data.items.find(i => i.code == 'balance')
      //   if (value && value.dataFlag) {
      //     this.src = `testing/${projectId}/FinalSettlement/${this.programId}/balance?token=${getToken()}&offlineHandle=1`
      //   } else {
      //     this.src = `testing/${projectId}/FinalSettlement/${this.programId}/balance/importer?token=${getToken()}&offlineHandle=1`
      //   }
      // } else {
      //   this.src = `testing/${projectId}/FinalSettlement/${this.programId}/balance/importer?token=${getToken()}&offlineHandle=1`
      // }

      if (this.abilityCode=='OtherReport'){
        this.src = `${microServiceVue3}testing/${this.projectId}/FinalSettlement/${this.programId}/basicInfo?token=${this.aitaxToken}&offlineHandle=${this.offlineHandle}`

      }else if (this.abilityCode=='SubjectMatch') {
        this.src = `${microServiceVue3}testing/${this.projectId}/FinalSettlement/${this.programId}/auto?token=${this.aitaxToken}&offlineHandle=${this.offlineHandle}`

      }else if (this.abilityCode=='CustomData') {
        this.src = `${microServiceVue3}testing/${this.projectId}/customData/${this.programId}/${this.reportId}?token=${this.aitaxToken}&offlineHandle=${this.offlineHandle}`

      }


      if (this.skuId){
        this.src = `${this.src}&skuId=${this.skuId}`
      }

      if (this.abilityCode){
        this.src = `${this.src}&ability=${this.abilityCode}`
      }





      if (this.isfinish) {
        this.src = this.src + '&isfinish=true'
      } else {
        this.src = this.src + '&isfinish=false'
      }
    }

  }
}
</script>
<style scoped lang="stylus">
.mainBox {
  background: #fff;
  padding: 16px;
  text-align: left;
  margin: 0;
  margin-right 0
  border-radius: 8px;

  .title {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #0E1429;
    line-height: 26px;
    margin-bottom 24px;
  }
}

.success {
  color #10CC99;
}

:deep() {
  .ant-tabs-nav-wrap {
    border-bottom: 1px solid #E6E8EA
  }
}

:deep() {
  micro-app[name=bankDataUploader] micro-app-body {
    min-height: 500px
    place-items flex-start

    .ant-input-affix-wrapper {
      padding 0 11px
    }

    #data-collection {
    }
  }
}
</style>
